// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from './views/LoginPage.vue';
import DashboardPage from './views/DashboardPage.vue';
import AdminUsersPage from './views/AdminUsersPage.vue';
import AdminClientesPage from './views/AdminClientesPage.vue';
import OrdenesServicio from './views/OrdenesServicio.vue';
import PerfilPage from './views/PerfilPage.vue';
import OperadorDashboard from './views/OperadorDashboard.vue';
import IngresarOpciones from './views/IngresarOpciones.vue';
import IndeasaPage from './views/Almacen/indeasaPage.vue';
import ApizacoPage from './views/Almacen/apizacoPage.vue';

const routes = [
    { path: '/', component: LoginPage },
    { path: '/Inicio', component: DashboardPage, meta: { requiresAuth: true, roles: [1, 2] } },
    { path: '/AdminUsuario', component: AdminUsersPage, meta: { requiresAuth: true, roles: [1, 2] } },
    { path: '/AdminCliente', component: AdminClientesPage, meta: { requiresAuth: true, roles: [1, 2] } },
    { path: '/AdminOrden', component: OrdenesServicio, meta: { requiresAuth: true, roles: [1, 2, 3] } },
    { path: '/Almacen/indaesa', component: IndeasaPage, meta: { requiresAuth: true, roles: [1, 2, 3] } },
    { path: '/Almacen/Apizaco', component: ApizacoPage, meta: { requiresAuth: true, roles: [1, 2, 3] } },
    { path: '/Perfil', component: PerfilPage, meta: { requiresAuth: true } },
    { path: '/Operador', component: OperadorDashboard, meta: { requiresAuth: true, roles: [1, 3] } },
    { path: '/ingresar', component: IngresarOpciones, meta: { requiresAuth: true, roles: [1, 3] } }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    const payload = token ? parseJwt(token) : null

    if (to.meta.requiresAuth) {
        if (token && isTokenValid(payload)) {
            // Verifica roles si la ruta lo requiere
            console.log(payload)
            if (to.meta.roles && !to.meta.roles.includes(payload.role_id)) {
                return next('/Inicio') // o '/403' si quieres página de prohibido
            }
            next()
        } else {
            localStorage.removeItem('token')
            next('/')
        }
    } else {
        if (to.path === '/' && token && isTokenValid(payload)) {
            next('/Inicio')
        } else {
            next()
        }
    }
})

function isTokenValid(payload) {
    if (!payload || !payload.exp) return false
    return payload.exp * 1000 > Date.now() // Laravel emite exp en segundos
}

function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        )
        return JSON.parse(jsonPayload)
    } catch (e) {
        console.error('Error al parsear el token:', e)
        return null
    }
}

export default router;
